import assets from './assets'
import authentication from './authentication'
import clients from './clients'
import dailyPrices from './dailyPrices'
import documents from './documents'
import fees from './fees'
import fxRates from './fxRates'
import holdings from './holdings'
import messages from './messages'
import portfolio from './portfolio'
import profile from './profile'
import requests from './requests'
import settings from './settings'
import transactions from './transactions'
import trade from './trade'
import featureFlags from './featureFlags'
import banks from './banks'

export default {
    assets,
    authentication,
    clients,
    dailyPrices,
    documents,
    fees,
    fxRates,
    holdings,
    messages,
    portfolio,
    profile,
    requests,
    settings,
    transactions,
    trade,
    featureFlags,
    banks,
}
